import { app } from '../../../../../app';
import { Controller } from './manage-shared-folder.controller';

app.component('companySharingCenterSharedFoldersManage', {
    bindings: {
        sharedFolder: '<',
        items: '<',
    },
    controller: Controller,
    templateUrl: require('./manage-shared-folder.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/manage-shared-folder.component..js